// extracted by mini-css-extract-plugin
export default {"selectableText":"CaseSelectableText_selectableText__ybW9K"};